module.exports = __webpack_public_path__ + "img/Aries.4becfd98.png";